//--------------------------------------------------------------------------------------------------
//# Imports

import React, { useEffect, useState } from 'react';
import Aos from "aos";
import "aos/dist/aos.css";
import image_generator from "../../scripts/GeneratorOperator";
import AlchmizerOperator from "./../../scripts/AlchmizerOperator.js";

import { usePrivy } from "@privy-io/react-auth";

import './alchmizerGUI.css'

// import default_image from '../../image/image_preview.webp';
import generating_placeholder_0 from '../../image/generating/generating_0.webp';
import generating_placeholder_1 from '../../image/generating/generating_1.webp';
import generating_placeholder_2 from '../../image/generating/generating_2.webp';
import generating_placeholder_3 from '../../image/generating/generating_3.webp';
import loading_placeholder from '../../image/generating/image_loading_preview.webp';
import shadow_avatar from '../../image/team-image-3.webp';
import generation_failed_placeholder from '../../image/generating/generation_failed.webp'
// import { all } from 'redux-saga/effects';












//--------------------------------------------------------------------------------------------------
//# Variables

const generating_placeholder_list = [
  generating_placeholder_0,
  generating_placeholder_1,
  generating_placeholder_2,
  generating_placeholder_3
];

const delay_gap = 100;
const default_negative_prompt = "out of frame, lowres, text, error, cropped, worst quality, low quality, jpeg artifacts, ugly, duplicate, morbid, mutilated, extra fingers, mutated hands, poorly drawn hands, poorly drawn face, mutation, deformed, blurry, dehydrated, bad anatomy, bad proportions, extra limbs, cloned face, disfigured, gross proportions, malformed limbs, missing arms, missing legs, extra arms, extra legs, fused fingers, too many fingers, long neck, username, watermark, signature"
const simplifier_prefix = "I NEED to test how the tool works with extremely simple prompts. DO NOT add any detail, just use it AS-IS:";

let parameter_dict = {"prompt": "",
                      "negative_prompt": "",
                      "quantity": 1,
                      "width": "",
                      "height": "",
                      "guidance_scale": "",
                      "num_inference_steps": "",
                      "model": ""};

let image_URL = shadow_avatar;
let default_image = shadow_avatar;

let generation_time = 0;
let pause_generation = false;

let mobile = window.innerWidth <= 600;
// let mobile = false;
// if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || ) ) {
//   console.log("Mobile device detected");
//   mobile = true;
// };

const model_dict = {"black-forest-labs/FLUX.1-dev": {"description": "FLUX.1 defines the new state-of-the-art in image synthesis. Our models set new standards in their respective model class. FLUX.1 [pro] and [dev] surpass popular  models like Midjourney v6.0, DALL·E 3 (HD) and SD3-Ultra in each of the following aspects: Visual Quality, Prompt Following, Size/Aspect Variability, Typography and Output Diversity. FLUX.1 [schnell] is the most advanced few-step model to date, outperforming not even its in-class competitors but also strong non-distilled models like Midjourney v6.0 and DALL·E 3 (HD) .  Our models are specifically finetuned to preserve the entire output diversity from pretraining.",
                                                     "link": "https://blackforestlabs.ai/announcing-black-forest-labs/"},
                    "SG161222/Realistic_Vision_V6.0_B1_noVAE": {"description":  "Latest (experimental) release of the Realistic Vision model specialized in creating photorealistic portraits.",
                                                     "link": "https://huggingface.co/SG161222/Realistic_Vision_V6.0_B1_noVAE"},
                    "stabilityai/stable-diffusion-xl-base-1.0": {"description": "A base model for stable diffusion by Stability AI.",
                                                     "link": "https://huggingface.co/stabilityai/stable-diffusion-xl-base-1.0"},
                    "runwayml/stable-diffusion-v1-5": {"description": "A stable diffusion model by Runway ML.",
                                                     "link": "https://huggingface.co/runwayml/stable-diffusion-v1-5"},
                    "prompthero/openjourney-v4": {"description": "A model by Prompthero for open-ended journey generation.",
                                                     "link": "https://huggingface.co/prompthero/openjourney-v4"},
                    "ByteDance/SDXL-Lightning": {"description": "A lightning-fast diffusion model by ByteDance.",
                                                     "link": "https://huggingface.co/ByteDance/SDXL-Lightning"},
                    "SG161222/RealVisXL_V4.0": {"description": "A diffusion model that excels in generating high-quality, photorealistic images.",
                                                     "link": "https://huggingface.co/SG161222/RealVisXL_V4.0"},
                    "SG161222/RealVisXL_V4.0_Lightning": {"description": "A streamlined version of RealVisXL_V4.0, designed for faster inference while still aiming for photorealism.",
                                                     "link": "https://huggingface.co/SG161222/RealVisXL_V4.0_Lightning"},
                    "DALL-E": {"description": "Text-to-image generation powered by OpenAI and ChatGPT.",
                                                     "link": "https://openai.com/index/dall-e-3/"}};




// let input_info = {'birth_info': {},
//                   'image_generator': {},
//                   'alchmizer': {},
//                   'output_settings': {},
//                   'range_info': {}};

                  
const default_input_info = {'birth_info':
                              {'hour': '8',
                               'minute': '0',
                               'second': '0',
                               'latitude': '40',
                               'longitude': '70'},
                            'image_generator': 
                              {'model': 'black-forest-labs/FLUX.1-dev',
                               'width': '512',
                               'height': '512',
                               'guidance_scale': '10',
                               'num_inference_steps': '10'},
                            'alchmizer': {},
                            'output_settings': {
                              'imageQuantity': '1'}};

const storage_info_dict = {'none': false,
                           'irys_Polygon': {'blockchain': 'Polygon',
                                            'provider': 'Irys'},
                           'irys_Solana': {'blockchain': 'Solana',
                                           'provider': 'Irys'},
                           'irys_PolygonAmoyTestnet': {'blockchain': 'Polygon Amoy Testnet',
                                                       'provider': 'Irys'},
                           'irys_SolanaDevnet': {'blockchain': 'Solana Devnet',
                                                 'provider': 'Irys'}};








//--------------------------------------------------------------------------------------------------
//# Functions

//AppStart                                                     
const AlchmizerGUI = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const { getAccessToken } = usePrivy();

  // Check default checklist options
  document.addEventListener("DOMContentLoaded", () => {
    let checkbox = document.querySelector('input[value="black-forest-labs/FLUX.1-dev"]');
    checkbox.checked = true; 
    checkbox = document.querySelector('input[value="256x256"]');
    checkbox.checked = true;
  });


  function pause(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  function mouseOver(event) {
    // console.log('\nAlchmizerGUI >>> RUNNING mouseOver()');
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.20)';
  }
  
  function mouseLeave(event) {
    // console.log('\nAlchmizerGUI >>> RUNNING mouseLeave()');
    let element = document.getElementById(event.target.id);
    element.style.transform = 'scale(1.0)';
  }

  async function handleMouseDown(event) {
    console.log('\nAlchmizerGUI.js >>> RUNNING handleMouseDown()');
    const element = document.getElementById(event.target.id);
    element.style.backgroundColor = '#949494';
  }


  async function displayImage(image_element, new_image) {
    console.log('\nAlchmizerGUI >>> RUNNING displayImage()');
    image_element.src = new_image;
    console.log('Image Displayed!', new_image);
    console.log('New Image src:', image_element.src);
  };

  function copyImageURL(event) {
    console.log('\nAlchmizerGUI >>> RUNNING copyImageURL()');
    let copied_image_URL = event.target.src;
    console.log("copyImageURL() -> Copied Image URL:", copied_image_URL);

    const image_element_ID = event.target.id.split('generatedImage_')[1];

    let model_name;
    for (const model in model_dict) {
      if (image_element_ID.includes(model)) {
        model_name = model;
      };
    };
    
    const copied_message_element = document.getElementById("copiedMessage_" + model_name);
    copied_message_element.style.opacity = 1;
    copied_message_element.style.transition = "none";

    navigator.clipboard.writeText(copied_image_URL)
    .then(() => {
      console.log("URL copied to clipboard:", copied_image_URL);
       // Keep the message visible for 2 seconds
       setTimeout(() => {
        copied_message_element.style.transition = "opacity 1s ease-in-out"; // Add fade-out transition
        copied_message_element.style.opacity = 0; // Gradually fade out
      }, 2000); // 2-second delay
    })
    .catch((err) => {
      console.error("Failed to copy URL:", err);
    });
  };





  function handleRangeCheckbox(event) {
    console.log('\nAlchmizerGUI >>> RUNNING handleRangeCheckbox()');

    updateRangeBoxes();
    const id = event.target.id;
    const checkbox = document.getElementById(id);
    // if (checkbox.checked) {
    //   input_info['range_info']['parameter'] = id;
    // } else {
    //   input_info['range_info']['parameter'] = '';
    // };
  };

  function updateRangeBoxes() {
    console.log('\nAlchmizerGUI >>> RUNNING updateRangeBoxes()');

    let all_unchecked = true;

    const batch_name_container = document.getElementById('batchNameContainer');
    const batch_button = document.getElementById('generateBatchButton');
    // const batch_link = document.getElementById('viewBatchLink');

    const range_checkboxes = document.querySelectorAll('.alchmizerGUIRangeCheckbox');
    // const range_checkbox_containers = document.querySelectorAll('.alchmizerGUIRangeContainer');
    range_checkboxes.forEach(box => {
      const corresponding_container = document.getElementById(box.value + '_Container');
      const corresponding_duplicate = document.getElementById(box.value + '_RangeDuplicate');
      const corresponding_interval_start = document.getElementById(box.value + '_IntervalStart');
      if (box.checked) {
        all_unchecked = false;
        box.disabled = false;
        batch_name_container.style.display = 'flex';
        batch_button.style.display = 'block';
        corresponding_container.classList.add('alchmizerGUIRangeContainer_checked');
        corresponding_container.classList.remove('alchmizerGUIRangeContainer_unchecked');
        corresponding_duplicate.style.display = "flex";
        corresponding_interval_start.style.display = "flex";
      } else {
        box.disabled = true;
        corresponding_container.classList.add('alchmizerGUIRangeContainer_unchecked');
        corresponding_container.classList.remove('alchmizerGUIRangeContainer_checked');
        corresponding_duplicate.style.display = "none";
        corresponding_interval_start.style.display = "none";
      }
    });

    if (all_unchecked) {
      batch_name_container.style.display = 'none';
      batch_button.style.display = 'none';
      range_checkboxes.forEach(box => {
        box.disabled = false;
        const corresponding_container = document.getElementById(box.value + '_Container');
        corresponding_container.classList.remove('alchmizerGUIRangeContainer_unchecked');
        const corresponding_interval_start = document.getElementById(box.value + '_IntervalStart');
        corresponding_interval_start.style.display = "none";
      });
    };
  };


  function handleSelectList(event) {
    console.log('\nAlchmizerGUI >>> RUNNING handleSelectList()');

    const value = event.target.value;
    // if (value.includes('gpt-image')) {

    // };    
  };

  function handleFieldChange(event) {
    
  };

  async function handleSubmitClick(event) {
    console.log('\nAlchmizerGUI >>> RUNNING handleSubmitClick()');

    const element_ID = event.target.id;
    document.getElementById(element_ID).style.backgroundColor = '#dbdbdb';
    let input_info = await assembleInputInfo();

    

    // Preview Generation
    if (element_ID === 'generatePreviewsButton') {
      for (var i = 1; i <= input_info['output_settings']['imageQuantity']; i++ ) {
        let image_element = document.getElementById('preview' + i.toString());
        await generatePreview(input_info['alchm_info'], image_element);
      };

    // Batch Generation
    } else if (element_ID === 'generateBatchButton') {
      let batch_settings = {};
      batch_settings['name'] = input_info['output_settings']['batchName'];
      batch_settings['quantity'] = input_info['output_settings']['imageQuantity'];
      batch_settings['range'] = input_info['range_info']['parameter'];
      batch_settings['start'] = input_info['range_info']['start']
      batch_settings['end'] = input_info['range_info']['end'];
      batch_settings['interval'] = input_info['range_info']['interval'];
      
      console.log('batch_settings', batch_settings);
      const response = await generateBatch(batch_settings);

      if (document.getElementById('viewBatchLink')) {
        document.getElementById('viewBatchLink').style.display = 'flex';
      };
    };
  };

  async function generatePreview(alchm_info, image_element) {
    console.log('\nAlchmizerGUI >>> RUNNING generatePreview()');

    const access_token = await getAccessToken();
    image_element.classList.add("spinImage");

    alchm_info = await AlchmizerOperator.alchmizerCall(alchm_info, access_token);

    image_URL = await alchm_info['imaginizer_info']['image_URL'];
    image_element.src = image_URL;
    image_element.classList.remove("spinImage");
  };

  async function generateBatch(batch_settings) {
    console.log('\nAlchmizerGUI >>> RUNNING generateBatch()');

    const access_token = await getAccessToken();

    const CSV_file = await AlchmizerOperator.alchmizerBatchCall(batch_settings, access_token);
  };

  async function assembleInputInfo() {
    console.log('\nAlchmizerGUI >>> RUNNING assembleInputInfo()');

    let input_info = {'birth_info': {},
                      'image_generator': {},
                      'alchmizer': {},
                      'output_settings': {},
                      'range_info': {}};


    // Birth Info
    let birth_info = {};
    birth_info['date'] = document.getElementById('date').value;
    birth_info['month'] = document.getElementById('month').value - 1;
    birth_info['year'] = document.getElementById('year').value;
    birth_info['hour'] = document.getElementById('hour').value;
    birth_info['minute'] = document.getElementById('minute').value;
    birth_info['second'] = document.getElementById('second').value;
    birth_info['latitude'] = document.getElementById('latitude').value;
    birth_info['longitude'] = document.getElementById('longitude').value;

    input_info['birth_info'] = structuredClone(birth_info);


    // Image Generator
    let image_generator = {};
    image_generator['model'] = document.getElementById('model').value;
    image_generator['width'] = document.getElementById('width').value;
    image_generator['height'] = document.getElementById('height').value;
    image_generator['guidance_scale'] = document.getElementById('guidance_scale').value;
    image_generator['num_inference_steps'] = document.getElementById('num_inference_steps').value;

    input_info['image_generator'] = structuredClone(image_generator);


    // Alchmizer
    let alchmizer = {};
    alchmizer['architecture'] = document.getElementById('architecture').value;

    input_info['alchmizer'] = structuredClone(alchmizer);
    

    // Output Settings
    let output_settings = {};
    output_settings['imageQuantity'] = document.getElementById('imageQuantity').value;
    output_settings['batchName'] = document.getElementById('batchName').value;
    output_settings['imageStorage'] = document.getElementById('imageStorage').value

    input_info['output_settings'] = structuredClone(output_settings);


    // Alchm Info
    let alchm_info = {};
    alchm_info['birth_info'] = input_info['birth_info'];
    alchm_info['imaginizer_info'] = input_info['image_generator'];
    alchm_info['imaginizer_info']['architecture'] = input_info['alchmizer']['architecture'];
    alchm_info['imaginizer_info']['image'] = 'avatar';
    alchm_info['imaginizer_info']['storage_info'] = storage_info_dict[output_settings['imageStorage']];
    alchm_info['logging_info'] = {'metadata': {'source': 'admin_console'}};

    input_info['alchm_info'] = structuredClone(alchm_info);


    // Range Info
    let range_info = {};
    range_info['start'] = structuredClone(alchm_info);
    range_info['end'] = structuredClone(alchm_info);
    range_info['interval'] = structuredClone(alchm_info);
    const range_checkboxes = document.querySelectorAll('.alchmizerGUIRangeCheckbox');
    let range_parameter = false;
    range_checkboxes.forEach(box => {
      if (box.checked) {
        range_parameter = box.value;
        range_info['parameter'] = range_parameter;
      };
    });
    // Birth Info Ranges
    if (range_parameter === 'birthday') {
      range_info['end']['birth_info']['date'] = document.getElementById('date_End').value;
      range_info['end']['birth_info']['month'] = document.getElementById('month_End').value - 1;
      range_info['end']['birth_info']['year'] = document.getElementById('year_End').value;
      range_info['interval']['birth_info']['date'] = document.getElementById('date_Interval').value;
      range_info['interval']['birth_info']['month'] = document.getElementById('month_Interval').value;
      range_info['interval']['birth_info']['year'] = document.getElementById('year_Interval').value;
      range_info['interval']['birth_info']['hour'] = 0;
      range_info['interval']['birth_info']['minute'] = 0;
      range_info['interval']['birth_info']['second'] = 0;
    } else if (range_parameter === 'birthTime') {
      range_info['end']['birth_info']['hour'] = document.getElementById('hour_End').value;
      range_info['end']['birth_info']['minute'] = document.getElementById('minute_End').value;
      range_info['end']['birth_info']['second'] = document.getElementById('second_End').value;
      range_info['interval']['birth_info']['date'] = 0;
      range_info['interval']['birth_info']['month'] = 0;
      range_info['interval']['birth_info']['year'] = 0;
      range_info['interval']['birth_info']['hour'] = document.getElementById('hour_Interval').value;
      range_info['interval']['birth_info']['minute'] = document.getElementById('minute_Interval').value;
      range_info['interval']['birth_info']['second'] = document.getElementById('second_Interval').value;
    } else if (range_parameter === 'birthLocation') {
      range_info['end']['birth_info']['latitude'] = document.getElementById('latitude_End').value;
      range_info['end']['birth_info']['longitude'] = document.getElementById('longitude_End').value;
      range_info['interval']['birth_info']['latitude'] = document.getElementById('latitude_Interval').value;
      range_info['interval']['birth_info']['longitude'] = document.getElementById('longitude_Interval').value;
    // Image Generator Ranges
    } else if (range_parameter === 'imageSize') {
      range_info['end']['imaginizer_info']['width'] = document.getElementById('width_End').value;
      range_info['end']['imaginizer_info']['height'] = document.getElementById('height_End').value;
      range_info['interval']['imaginizer_info']['width'] = document.getElementById('width_Interval').value;
      range_info['interval']['imaginizer_info']['height'] = document.getElementById('height_Interval').value;
    } else if (range_parameter === 'guidanceScale') {
      range_info['end']['imaginizer_info']['guidance_scale'] = document.getElementById('guidanceScale_End').value;
      range_info['interval']['imaginizer_info']['guidance_scale'] = document.getElementById('guidanceScale_Interval').value;
    } else if (range_parameter === 'inferenceSteps') {
      range_info['end']['imaginizer_info']['num_inference_steps'] = document.getElementById('inferenceSteps_End').value;
      range_info['interval']['imaginizer_info']['num_inference_steps'] = document.getElementById('inferenceSteps_Interval').value;
    };

    input_info['range_info'] = structuredClone(range_info);

    console.log("input_info:", input_info);

    return(input_info);
  };



//--------------------------------------------------------------------------------------------------
//# HTML

  return (
    <div className='alchmizerGUI' id="anchorElement_AlchmizerGUI">
    

    {/* ---------- Birth Info ---------- */}
      <div className='alchmizerGUIbannerTitleContainer' id='banner_alchmizerGUITitleContainer' >
        <span className='alchmizerGUIbannerTitle' id="banner_alchmizerGUITitleContainer">
          Birth Info
        </span>
      </div>


      {/***** Birthday *****/}
      <div className='alchmizerGUItextContainer'>
        <div className='alchmizerGUIrow'>
          <div className='alchmizerGUITitle'>
            Birthday
          </div>
          <div className='alchmizerGUIRangeContainer' id='birthday_Container'>
            <div className='alchmizerGUIRangeText'>
              Range:
            </div>
            <input className="alchmizerGUIRangeCheckbox" type="checkbox" value="birthday" id='birthday_Box' onChange={handleRangeCheckbox} />
          </div>
        </div>
        <div className="alchmizerGUIrow">
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Month: 
          </div>
          <input className='alchmizerGUInumberEntry' defaultValue='4' id='month' onChange={handleFieldChange}
            placeholder="" />
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Day: 
          </div>
          <input className='alchmizerGUInumberEntry' defaultValue='20' id='date' onChange={handleFieldChange}
            placeholder="" />
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Year: 
          </div>
          <input className='alchmizerGUInumberEntry' defaultValue='1990' id='year' onChange={handleFieldChange}
            placeholder="" />
          <div className='alchmizerGUIIntervalTextContainer' id='birthday_IntervalStart' style={{display:"none"}}>
            <div className='alchmizerGUIRangeText'>
              Start
            </div>
          </div>
        </div>
        {/* Duplicates */}
        <div className="alchmizerGUIRangeDuplicate" id='birthday_RangeDuplicate' style={{display: "none"}}>
          <div className="alchmizerGUIrow">
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Month: 
            </div>
            <input className='alchmizerGUInumberEntry' defaultValue='4' id='month_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Day: 
            </div>
            <input className='alchmizerGUInumberEntry' defaultValue='20' id='date_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Year: 
            </div>
            <input className='alchmizerGUInumberEntry' defaultValue='1990' id='year_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                End
              </div>
            </div>
          </div>
          <div className="alchmizerGUIrow">
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Month: 
            </div>
            <input className='alchmizerGUInumberEntry' id='month_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Day: 
            </div>
            <input className='alchmizerGUInumberEntry' id='date_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Year: 
            </div>
            <input className='alchmizerGUInumberEntry' id='year_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                Interval
              </div>
            </div>
          </div>
        </div>
      </div>


      {/***** Birth Time *****/}
      <div className='alchmizerGUItextContainer'>
        <div className="alchmizerGUIrow">
          <div className='alchmizerGUITitle'>
            Birth Time
          </div>
          <div className='alchmizerGUIRangeContainer' id='birthTime_Container'>
            <div className='alchmizerGUIRangeText'>
              Range:
            </div>
            <input className="alchmizerGUIRangeCheckbox" type="checkbox" value="birthTime" id='birthTime_Box' onChange={handleRangeCheckbox} />
          </div>
        </div>
        <div className="alchmizerGUIrow">
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Hour: 
          </div>
          <input className='alchmizerGUInumberEntry' id='hour' defaultValue='8' onChange={handleFieldChange} />
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Minute: 
          </div>
          <input className='alchmizerGUInumberEntry' id='minute' defaultValue='0' onChange={handleFieldChange} />
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Second: 
          </div>
          <input className='alchmizerGUInumberEntry' id='second' defaultValue='0' onChange={handleFieldChange} />
          <div className='alchmizerGUIIntervalTextContainer' id='birthTime_IntervalStart' style={{display:"none"}}>
            <div className='alchmizerGUIRangeText'>
              Start
            </div>
          </div>
        </div>
        {/* Duplicates */}
        <div className="alchmizerGUIRangeDuplicate" id='birthTime_RangeDuplicate' style={{display: "none"}}>
          <div className="alchmizerGUIrow">
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Hour: 
            </div>
            <input className='alchmizerGUInumberEntry' id='hour_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Minute: 
            </div>
            <input className='alchmizerGUInumberEntry' id='minute_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Second: 
            </div>
            <input className='alchmizerGUInumberEntry' id='second_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                End
              </div>
            </div>
          </div>
          <div className="alchmizerGUIrow">
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Hour: 
            </div>
            <input className='alchmizerGUInumberEntry' id='hour_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Minute: 
            </div>
            <input className='alchmizerGUInumberEntry' id='minute_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Second: 
            </div>
            <input className='alchmizerGUInumberEntry' id='second_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                Interval
              </div>
            </div>
          </div>
        </div>
      </div>


      {/***** Birth Location *****/}
      <div className='alchmizerGUItextContainer'>
         <div className="alchmizerGUIrow">
          <div className='alchmizerGUITitle'>
            Birth Location
          </div>
          <div className='alchmizerGUIRangeContainer' id='birthLocation_Container'>
            <div className='alchmizerGUIRangeText'>
              Range:
            </div>
            <input className="alchmizerGUIRangeCheckbox" type="checkbox" value="birthLocation" id='birthLocation_Box' onChange={handleRangeCheckbox} />
          </div>
        </div>
        <div className="alchmizerGUIrow">
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Latitude: 
          </div>
          <input className='alchmizerGUInumberEntry' id='latitude' defaultValue="42" onChange={handleFieldChange} />
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Longitude: 
          </div>
          <input className='alchmizerGUInumberEntry' id='longitude' defaultValue="70" onChange={handleFieldChange} />
          <div className='alchmizerGUIIntervalTextContainer' id='birthLocation_IntervalStart' style={{display:"none"}}>
            <div className='alchmizerGUIRangeText'>
              Start
            </div>
          </div>
        </div>
        {/* Duplicates */}
        <div className="alchmizerGUIRangeDuplicate" id='birthLocation_RangeDuplicate' style={{display: "none"}}>
          <div className="alchmizerGUIrow">
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Latitude: 
            </div>
            <input className='alchmizerGUInumberEntry' id='latitude_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Longitude: 
            </div>
            <input className='alchmizerGUInumberEntry' id='longitude_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                End
              </div>
            </div>
          </div>
          <div className="alchmizerGUIrow">
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Latitude: 
            </div>
            <input className='alchmizerGUInumberEntry' id='latitude_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Longitude: 
            </div>
            <input className='alchmizerGUInumberEntry' id='longitude_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                Interval
              </div>
            </div>
          </div>
        </div>
      </div>






    {/* ---------- Image Generator ---------- */}
      <div className='alchmizerGUIbannerTitleContainer' id='banner_alchmizerGUITitleContainer' >
        <span className='alchmizerGUIbannerTitle' id="banner_alchmizerGUITitleContainer">
          Image Generator
        </span>
      </div>



      {/***** Model *****/}
      <div className='alchmizerGUItextContainer'>
        <div className='alchmizerGUITitle'>
          Model
        </div>
      </div>
      <div className='alchmizerGUItextContainer'>
        <select className='alchmizerGUIdropdownList' id='model' onChange={handleSelectList}>
          <option value="gpt-image-1.5">gpt-image-1.5</option>
          <option value="gpt-image-1">gpt-image-1</option>
          <option value="gpt-image-1-mini">gpt-image-1-mini</option>
          <option value="dall-e-3">dall-e-3</option>
          <option value="dall-e-2">dall-e-2</option>
          <option value="black-forest-labs/FLUX.1-dev">black-forest-labs/FLUX.1-dev</option>
          <option value="stabilityai/stable-diffusion-xl-base-1.0">stabilityai/stable-diffusion-xl-base-1.0</option>
          <option value="runwayml/stable-diffusion-v1-5">runwayml/stable-diffusion-v1-5</option>
          <option value="prompthero/openjourney-v4">prompthero/openjourney-v4</option>
          <option value="ByteDance/SDXL-Lightning">ByteDance/SDXL-Lightning</option>
          <option value="SG161222/RealVisXL_V4.0">SG161222/RealVisXL_V4.0</option>
          <option value="SG161222/RealVisXL_V4.0_Lightning">SG161222/RealVisXL_V4.0_Lightning</option>
          <option value="SG161222/Realistic_Vision_V6.0_B1_noVAE">SG161222/Realistic_Vision_V6.0_B1_noVAE</option>
          
        </select>
      </div>
      

      {/***** Image Size *****/}
      <div className='alchmizerGUItextContainer'>
         <div className="alchmizerGUIrow">
          <div className='alchmizerGUITitle'>
            Image Size
          </div>
          <div className='alchmizerGUIRangeContainer' id='imageSize_Container'>
            <div className='alchmizerGUIRangeText'>
              Range:
            </div>
            <input className="alchmizerGUIRangeCheckbox" type="checkbox" value="imageSize" id='imageSize_Box' onChange={handleRangeCheckbox} />
          </div>
        </div>
        <div className="alchmizerGUIrow">
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Width:
          </div>
          <input className='alchmizerGUInumberEntry' id='width' defaultValue="512" onChange={handleFieldChange} />
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Height:
          </div>
          <input className='alchmizerGUInumberEntry' id='height' defaultValue="512" onChange={handleFieldChange} />
          <div className='alchmizerGUIIntervalTextContainer' id='imageSize_IntervalStart' style={{display:"none"}}>
            <div className='alchmizerGUIRangeText'>
              Start
            </div>
          </div>
        </div>
        {/* Duplicates */}
        <div className="alchmizerGUIRangeDuplicate" id='imageSize_RangeDuplicate' style={{display: "none"}}>
          <div className="alchmizerGUIrow">
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Width: 
            </div>
            <input className='alchmizerGUInumberEntry' id='width_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Height: 
            </div>
            <input className='alchmizerGUInumberEntry' id='height_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                End
              </div>
            </div>
          </div>
          <div className="alchmizerGUIrow">
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Width: 
            </div>
            <input className='alchmizerGUInumberEntry' id='width_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIText alchmizerGUILabel'>
              Height: 
            </div>
            <input className='alchmizerGUInumberEntry' id='height_Interval' defaultValue="0" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                Interval
              </div>
            </div>
          </div>
        </div>
      </div>


      {/***** Guidance Scale *****/}
      <div className='alchmizerGUItextContainer'>
         <div className="alchmizerGUIrow">
          <div className='alchmizerGUITitle'>
            Guidance Scale
          </div>
          <div className='alchmizerGUIRangeContainer' id='guidance_scale_Container'>
            <div className='alchmizerGUIRangeText'>
              Range:
            </div>
            <input className="alchmizerGUIRangeCheckbox" type="checkbox" value="guidance_scale" id='guidance_scale_Box' onChange={handleRangeCheckbox} />
          </div>
        </div>
        <div className="alchmizerGUIrow">
          <input className='alchmizerGUInumberEntry' id='guidance_scale' defaultValue="10" onChange={handleFieldChange} />
          <div className='alchmizerGUIhelperText'>
            (1 to 20)
          </div>
          <div className='alchmizerGUIIntervalTextContainer' id='guidance_scale_IntervalStart' style={{display:"none"}}>
            <div className='alchmizerGUIRangeText'>
              Start
            </div>
          </div>
        </div>
        {/* Duplicates */}
        <div className="alchmizerGUIRangeDuplicate" id='guidance_scale_RangeDuplicate' style={{display: "none"}}>
          <div className="alchmizerGUIrow">
            <input className='alchmizerGUInumberEntry' id='guidance_scale_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIhelperText'>
              (1 to 20)
            </div>
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                End
              </div>
            </div>
          </div>
          <div className="alchmizerGUIrow">
            <input className='alchmizerGUInumberEntry' id='guidance_scale_Interval' defaultValue="1" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIhelperText'>
              (1 to 20)
            </div>
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                Interval
              </div>
            </div>
          </div>
        </div>
      </div>


      {/***** Inference Steps *****/}
      <div className='alchmizerGUItextContainer'>
         <div className="alchmizerGUIrow">
          <div className='alchmizerGUITitle'>
            Inference Steps
          </div>
          <div className='alchmizerGUIRangeContainer' id='num_inference_steps_Container'>
            <div className='alchmizerGUIRangeText'>
              Range:
            </div>
            <input className="alchmizerGUIRangeCheckbox" type="checkbox" value="num_inference_steps" id='num_inference_steps_Box' onChange={handleRangeCheckbox} />
          </div>
        </div>
        <div className="alchmizerGUIrow">
          <input className='alchmizerGUInumberEntry' id='num_inference_steps' defaultValue="10" onChange={handleFieldChange} />
          <div className='alchmizerGUIhelperText'>
            (1 to 100)</div>
          <div className='alchmizerGUIIntervalTextContainer' id='num_inference_steps_IntervalStart' style={{display:"none"}}>
            <div className='alchmizerGUIRangeText'>
              Start
            </div>
          </div>
        </div>
        {/* Duplicates */}
        <div className="alchmizerGUIRangeDuplicate" id='num_inference_steps_RangeDuplicate' style={{display: "none"}}>
          <div className="alchmizerGUIrow">
            <input className='alchmizerGUInumberEntry' id='num_inference_steps_End' onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIhelperText'>
              (1 to 100)
            </div>
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                End
              </div>
            </div>
          </div>
          <div className="alchmizerGUIrow">
            <input className='alchmizerGUInumberEntry' id='num_inference_steps_Interval' defaultValue="1" onChange={handleFieldChange}
              placeholder="" />
            <div className='alchmizerGUIhelperText'>
              (1 to 100)
            </div>
            <div className='alchmizerGUIIntervalTextContainer' id=''>
              <div className='alchmizerGUIRangeText'>
                Interval
              </div>
            </div>
          </div>
        </div>
      </div>





    {/* ---------- Alchmizer ---------- */}
      <div className='alchmizerGUIbannerTitleContainer' id='banner_alchmizerGUITitleContainer' >
        <span className='alchmizerGUIbannerTitle' id="banner_alchmizerGUITitleContainer">
          Alchmizer
        </span>
      </div>


      {/***** Architecture *****/}
      <div className='alchmizerGUItextContainer'>
        <div className='alchmizerGUITitle'>
          Architecture
        </div>
      </div>
      <div className='alchmizerGUItextContainer'>
        <select className='alchmizerGUIdropdownList' id='architecture' onChange={handleSelectList}>
          <option value="Midjourney Algorithm">Midjourney Algorithm</option>
          <option value="DALL-E Algorithm">DALL-E Algorithm</option>
        </select>
      </div>






    {/* ---------- Output Settings ---------- */}
      <div className='alchmizerGUIbannerTitleContainer' id='banner_alchmizerGUITitleContainer' >
        <span className='alchmizerGUIbannerTitle' id="banner_alchmizerGUITitleContainer">
          Output Settings
        </span>
      </div>


      {/***** Image Quantity *****/}
      <div className='alchmizerGUItextContainer'>
         <div className="alchmizerGUIrow">
          <div className='alchmizerGUITitle'>
            Image Quantity (per interval)
          </div>
        </div>
        <div className="alchmizerGUIrow">
          <input className='alchmizerGUInumberEntry' id='imageQuantity' defaultValue='1' onChange={handleFieldChange} />
          <div className='alchmizerGUIhelperText'>
            (1 to 10)</div>
        </div>
        <div className="alchmizerGUIrow">
          <div className='alchmizerGUIText alchmizerGUILabel'>
            Total Quantity:
          </div>
          <div className='alchmizerGUInumberDisplay'>
            TBD
          </div>
        </div>
      </div>


      {/***** Image Storage *****/}
      <div className='alchmizerGUItextContainer'>
        <div className='alchmizerGUITitle'>
          Image Storage
        </div>
      </div>
      <div className='alchmizerGUItextContainer'>
        <select className='alchmizerGUIdropdownList' id='imageStorage' onChange={handleSelectList}>
          <option value="none">None (temporary images)</option>
          <option value="irys_Polygon">Irys - POL Mainnet</option>
          <option value="irys_Solana">Irys - SOL Mainnet</option>
          <option value="irys_PolygonAmoyTestnet">Irys - POL Amoy Testnet</option>
          <option value="irys_SolanaDevnet">Irys - SOL Devnet</option>
        </select>
      </div>


      {/***** Batch Name *****/}
      <div className='alchmizerGUItextContainer' id='batchNameContainer' style={{display: 'none'}}>
        <div className="alchmizerGUIrow">
          <div className='alchmizerGUITitle'>
            Batch Name
          </div>
        </div>
        <div className="alchmizerGUIrow">
          <input className='alchmizerGUItextEntry' id='batchName' defaultValue="" placeholder="" onChange={handleFieldChange} />
        </div>
      </div>


      {/***** Generate Batch Button *****/}
      <div className='alchmizerGUItextContainer alchmizerGUIsubmitButtonContainer'>
        <div className="alchmizerGUIsubmitButton alchmizerGUIgenerateButton" id="generateBatchButton" style={{display: 'none'}} onMouseDown={handleMouseDown} onMouseUp={handleSubmitClick} onTouchStart={handleMouseDown} onTouchEnd={handleSubmitClick}>
          Generate Batch
        </div>
      </div>

      {/***** Batch Link *****/}
      <div className='alchmizerGUItextContainer'>
        <div className="alchmizerGUIrow">
          <a className='alchmizerGUILink' id='viewBatchLink' style={{display: 'none'}}
          href='https://www.youtube.com/watch?v=ZZ5LpwO-An4' target='_blank' rel='noreferrer'>
            View Batch →
          </a>
        </div>
      </div>







    {/* ---------- Previews ---------- */}
      <div className='alchmizerGUIbannerTitleContainer' id='banner_alchmizerGUITitleContainer' >
        <span className='alchmizerGUIbannerTitle' id="banner_alchmizerGUITitleContainer">
          Previews
        </span>
      </div>

      {/***** Generate Previews Button *****/}
      <div className='alchmizerGUItextContainer alchmizerGUIsubmitButtonContainer'>
        <div className="alchmizerGUIsubmitButton alchmizerGUIgenerateButton" id="generatePreviewsButton" onMouseDown={handleMouseDown} onMouseUp={handleSubmitClick} onTouchStart={handleMouseDown} onTouchEnd={handleSubmitClick}>
          Generate Previews
        </div>
      </div>

      <div className="alchmizerGUIrow">
        <div className="alchmizerGUIimageOutputContainer">
          
          <div className='alchmizerGUITitle'>1.</div>
          <img src={image_URL} alt='' id='preview1' className='alchmizerGUIgeneratedImage' onClick={copyImageURL}/>
          <div className='alchmizerGUITitle'>2.</div>
          <img src={image_URL} alt='' id='preview2' className='alchmizerGUIgeneratedImage' onClick={copyImageURL}/>
          <div className='alchmizerGUITitle'>3.</div>
          <img src={image_URL} alt='' id='preview3' className='alchmizerGUIgeneratedImage' onClick={copyImageURL}/>
          <div className='alchmizerGUITitle'>4.</div>
          <img src={image_URL} alt='' id='preview4' className='alchmizerGUIgeneratedImage' onClick={copyImageURL}/>
          <div className='alchmizerGUITitle'>5.</div>
          <img src={image_URL} alt='' id='preview5' className='alchmizerGUIgeneratedImage' onClick={copyImageURL}/>
        </div>
      </div>
      

    </div>
  )
}

export default AlchmizerGUI